import styled from 'styled-components';

export const Form = styled.div`
  margin: 20px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
